import * as Sentry from "@sentry/vue";

import type { App } from "vue";
import type { Router } from "vue-router";
export const initSentry = (app: App, router: Router) => {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,

    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
  });
};
